import React from "react";
import Nav from "../components/Nav";
import SearchResults from "../components/SearchResults";

function Search() {
  return (
    <div>
      <section className="">
        <Nav />
        <SearchResults />
      </section>
    </div>
  );
}

export default Search;
